window.DatoCmsPlugin.init((plugin) => {
  plugin.startAutoResizer();

  if (!plugin.getFieldValue(plugin.fieldPath)) {
    plugin.setFieldValue(plugin.fieldPath, (new Date()).toISOString());
  }
});
